export default class Select2Util {

  static initSelect2 () {
    const $elements = jQuery('[data-s2]');

    if (!$elements.length) {
      return;
    }

    $elements.each(function () {
      const $element = jQuery(this);
      const config = $element.data('s2-config') ?? {};

      if ($element.length) {
        $element.select2(config);
      }
    });

  }

}